module.exports = __webpack_public_path__ + "img/FZLC_6.a7b00338.jpg";